import React from 'react';
import { useI18n } from '../i18n';

const LOGO_URL = 'https://cdn.flexcover.app/img/logo.png';

// 品牌化启动 loading:居中 logo + "FlexCover is loading…" + 旋转弧线,
// 替代裸文本的 "Connecting to Shopify…"。public/index.html 的 #root 里有
// 同款静态版(React 挂载前的首帧),首次渲染会清空 #root 无缝接管 ——
// 两处样式需同步修改(静态版文案保持英语:那时还读不到语言偏好)。
export default function BrandLoading({ text }) {
  const { t } = useI18n();
  return (
    <div
      role="status"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff'
      }}
    >
      <style>{'@keyframes pp-spin{to{transform:rotate(360deg)}}'}</style>
      <div style={{ textAlign: 'center' }}>
        {/* logo 原图四周有约 25% 的白边,这里裁掉只留中间 50% 的盾牌图形,
            观感与参考图的应用图标大小一致 */}
        <div style={{ width: 104, height: 104, margin: '0 auto', overflow: 'hidden' }}>
          <img
            src={LOGO_URL}
            alt=""
            width={208}
            height={208}
            style={{ display: 'block', maxWidth: 'none', margin: '-52px 0 0 -52px' }}
          />
        </div>
        <div style={{ marginTop: 24, fontSize: 20, fontWeight: 700, color: '#1a1a1a' }}>
          {text || t('chrome.loadingBrand')}
        </div>
        <div
          style={{
            width: 26,
            height: 26,
            margin: '28px auto 0',
            borderRadius: '50%',
            border: '3px solid rgba(0,0,0,0.08)',
            borderTopColor: '#8c9196',
            animation: 'pp-spin 0.8s linear infinite'
          }}
        />
      </div>
    </div>
  );
}
